import React from "react";
import { useParams } from "react-router-dom";
import Dashboard from "src/components/DashboardComponents/Dashboard";
import DefaultDashboard from "../../components/DashboardComponents/Dashboard/defaultDashboard";

const Home: React.FC = () => {
	const params = useParams<{
        dashboardId: string;
    }>();
	
	if(!params.dashboardId)
		return <DefaultDashboard />;

	return (
		<Dashboard dashboardId={params.dashboardId}/>
	);
};

export default Home;
